module.exports = __webpack_public_path__ + "static/img/pdk-barnner.145b53b6.jpg";